export type StatsState = {
  stats: Stats;
};

export type Stats = {
  [propName: string]: number;
  limit_maxbytes: number;
  bytes: number;
  get_hits: number;
  get_misses: number;
  cmd_flush: number;
  cmd_set: number;
  curr_connections: number;
  curr_items: number;
  evictions: number;
  total_connections: number;
  delete_hits: number;
  delete_misses: number;
  incr_hits: number;
  incr_misses: number;
  decr_hits: number;
  decr_misses: number;
  cas_hits: number;
  cas_misses: number;
  touch_hits: number;
  touch_misses: number;
};

export enum StatType {
  PROCESSED = "PROCESSED",
  SLAB = "SLAB",
  PREFIX = "PREFIX",
  COMPOUND = "COMPOUND",
  KEY = "KEY",
  WATCHER = "WATCHER",
  RAW_INFLUXDB = "RAW_INFLUXDB",
}
